import { LocalizedTextModel } from "src/app/admin/product-services/shared/models/LocalizedTextModel";
import { Language } from "src/app/master/models/language";

export class LWAReason {
    id: number = 0;
    reason: string = '';
    LocationId: number = 0;
    isEditing?: boolean = false;
    language?: Language;
    localizedReason: LocalizedTextModel[] = [];
    localizedRowId?: string;
    _prevLanguageId: number = 1;
}
